import { render, staticRenderFns } from "./refer.vue?vue&type=template&id=c43a9e56&scoped=true"
import script from "./refer.vue?vue&type=script&lang=js"
export * from "./refer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43a9e56",
  null
  
)

export default component.exports